import { useMemo } from 'react';
import styled from 'styled-components';
import { ICommentFieldsFragment } from '../../../utils/apollo/graphqlSchema';
import { theme } from '../../../styles/theme';

interface IProps {
  comments: ICommentFieldsFragment[];
}

interface IConversationInfoResult {
  repliesAmount: number;
  imagesAmount: number;
}

const List = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;

  li + li::before {
    content: ' · ';
  }
`;
const ListItem = styled.li`
  display: inline;
  font-size: 12px;
  font-weight: 400;
  color: ${theme.colors.mainBlue};
`;

const ConversationThreadSummary = ({ comments }: IProps) => {
  const { repliesAmount, imagesAmount } = useMemo(
    () =>
      comments.reduce<IConversationInfoResult>(
        (acc, comment, commentIndex) => {
          if (commentIndex > 0) {
            acc.repliesAmount++;
          }
          if (comment.attachedImageEmbed) {
            acc.imagesAmount++;
          }

          return acc;
        },
        {
          repliesAmount: 0,
          imagesAmount: 0,
        },
      ),
    [comments],
  );

  if (!repliesAmount && !imagesAmount) {
    return null;
  }

  return (
    <List>
      {repliesAmount > 0 && (
        <ListItem>
          {repliesAmount} {repliesAmount === 1 ? 'reply' : 'replies'}
        </ListItem>
      )}
      {imagesAmount > 0 && (
        <ListItem>
          {imagesAmount} {imagesAmount === 1 ? 'image' : 'images'}
        </ListItem>
      )}
    </List>
  );
};

export default ConversationThreadSummary;
